import * as prismicHelpers from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';

import type { PrismicCustomData } from '@yoweb/prismic-slicemachine/types/prismic-types';
import type { Primary, Item } from '@yoweb/prismic-slicemachine/slices/FaqSlice/FaqSliceTypes';
import type { ReversedAppDomains } from '@yoweb/prismic-slicemachine/constants/config';
import { replaceUrlsInPrismicContent } from '@yoweb/prismic-slicemachine/utils/contentUtil';
import { htmlSerializerFaqPage } from '@yoweb/ui/utils/prismic';
import { Title } from '@yoweb/ui/components/typography';

export interface QuestionItemViewProps {
  prismicData: PrismicCustomData<Primary, Item> | null;
  reversedDomains?: ReversedAppDomains;
  internalURLs: string[];
}

const FAQ_GROUP_SLICE_TYPE = 'faq_group_slice';

export const mapQuestionItems = ({
  prismicData,
  reversedDomains,
  internalURLs,
}: QuestionItemViewProps) => {
  const data = prismicData?.data;
  const slices = data?.slices;
  // eslint-disable-next-line eqeqeq
  if (slices == null) {
    return null;
  }

  return slices
    .map((faqSection, idx) => {
      if (faqSection.slice_type !== FAQ_GROUP_SLICE_TYPE) {
        return null;
      }
      const category = prismicHelpers.asText(faqSection.primary.sectionName);
      const categoryId = faqSection.primary.sectionId;
      const questions = faqSection.items.map((item) => {
        const itemAnswer = replaceUrlsInPrismicContent(item.answer, reversedDomains || {});
        return {
          questionId: item.questionId,
          contentTitle: (
            <Title size="xs" weight="regular">
              {prismicHelpers.asText(item.question)}
            </Title>
          ),
          contentBody: (
            <PrismicRichText
              field={itemAnswer}
              components={htmlSerializerFaqPage(internalURLs)}
              key={`${category}-${idx}`}
            />
          ),
        };
      });

      return { category, categoryId, questions };
    })
    .filter(Boolean);
};
